module.exports = __webpack_public_path__ + "static/media/1roup 2@3x@3x 2.ecb9c9c4.png";